module.exports = __webpack_public_path__ + "img/IMG_8933.682b6640.jpg";